import { MenuItem, TableCell, TableRow } from "@mui/material";
import { useState } from "react";
import { useMutation } from "react-query";
import BootstrapModal from "react-bootstrap/Modal";
import useLang from "Shared/hooks/useLanguage";
import { toast } from "react-toastify";
import {
  StyledDropButtonThreeDots,
  StyledDropMenuMoreAction,
} from "Utils/Style/Dropdownstyle";
import { BatchControlsToggleStatus } from "Services/BatchControls/BatchControls";
import PermissionComponent, {
  getPermissionDisplayName,
} from "Shared/Common/Permissions/PermissionComponent";

function InactiveControlsRow({ row, refetch }: any) {
  const { t } = useLang();
  const [anchorEl, setAnchorEl] = useState<any>({ dropdown1: null });
  const [showActivateModal, setShowActivateModal] = useState(false);

  const handleClick = (event: any, name: string) =>
    setAnchorEl({ ...anchorEl, [name]: event.currentTarget });

  const handleClose = (name: string) =>
    setAnchorEl({ ...anchorEl, [name]: null });

  /* -------- useMutation: Activate -------- */
  const activateMutation = useMutation(
    (id: number) => BatchControlsToggleStatus(id),
    {
      onSuccess: (res: any) => {
        if (res?.data?.statusCode === 200) {
          toast.success(res?.data?.responseMessage);
          handleClose("dropdown1");
          setShowActivateModal(false);
          refetch();
        } else {
          toast.error(res?.data?.responseMessage || t("Something went wrong."));
        }
      },
      onError: () => { toast.error(t("An unexpected error occurred.")); },
    }
  );

  const handleActivate = () => {
    if (!row.batchControlId) return toast.info(t("No Row Selected"));
    activateMutation.mutate(row.batchControlId);
  };

  const openActivateModal = () => {
    handleClose("dropdown1");
    setShowActivateModal(true);
  };

  return (
    <>
      <TableRow className="h-30px">
        {/* Actions */}
        <TableCell>
          <div className="d-flex justify-content-center">
            <StyledDropButtonThreeDots
              id={`InactiveControl3Dots_${row.batchControlId}`}
              aria-haspopup="true"
              onClick={(e: any) => handleClick(e, "dropdown1")}
              className="btn btn-light-info btn-sm btn-icon moreactions min-w-auto rounded-4"
            >
              <i className="bi bi-three-dots-vertical p-0 icon" />
            </StyledDropButtonThreeDots>
            <StyledDropMenuMoreAction
              anchorEl={anchorEl.dropdown1}
              open={Boolean(anchorEl.dropdown1)}
              onClose={() => handleClose("dropdown1")}
              anchorOrigin={{ vertical: "top", horizontal: "left" }}
              transformOrigin={{ vertical: "top", horizontal: "left" }}
            >
              <PermissionComponent
                moduleName="Oncology LIS"
                pageName="Controls"
                permissionIdentifier="Active"
              >
                {({ pageName, moduleName, permissionIdentifier }) => (
                  <MenuItem className="p-0">
                    <a
                      id={`InactiveControlActivate_${row.batchControlId}`}
                      className="w-150px p-0 text-dark"
                      onClick={openActivateModal}
                    >
                      <div className="menu-item px-3">
                        <i className="fa fa-check-circle text-primary mr-2 w-20px" />
                        {getPermissionDisplayName(
                          pageName,
                          moduleName,
                          permissionIdentifier,
                          "Active"
                        )}
                      </div>
                    </a>
                  </MenuItem>
                )}
              </PermissionComponent>
            </StyledDropMenuMoreAction>
          </div>
        </TableCell>

        {/* Controls Name */}
        <TableCell sx={{ width: "max-content" }}>
          <div style={{ width: "max-content" }}>{row.controlName}</div>
        </TableCell>

        {/* Controls Value */}
        <TableCell sx={{ width: "max-content" }}>
          <div style={{ width: "max-content" }}>{row.controlValue}</div>
        </TableCell>

        {/* Current Lot # */}
        <TableCell sx={{ width: "max-content" }}>
          <div style={{ width: "max-content" }}>{row.currentLot}</div>
        </TableCell>

        {/* Previous Lot # */}
        <TableCell sx={{ width: "max-content" }}>
          <div style={{ width: "max-content" }}>{row.previousLot}</div>
        </TableCell>

        {/* Controls Type */}
        <TableCell sx={{ width: "max-content" }}>
          <div style={{ width: "max-content" }}>{row.controlType}</div>
        </TableCell>
      </TableRow>

      {/* Activate Confirmation Modal */}
      <BootstrapModal
        show={showActivateModal}
        onHide={() => setShowActivateModal(false)}
        backdrop="static"
        keyboard={false}
      >
        <BootstrapModal.Header closeButton className="bg-light-primary m-0 p-5">
          <h4>{t("Active Control")}</h4>
        </BootstrapModal.Header>
        <BootstrapModal.Body>
          {t("Are you sure you want to activate this control?")}
        </BootstrapModal.Body>
        <BootstrapModal.Footer className="p-0">
          <button
            id={`InactiveControlModalActivateCancel_${row.batchControlId}`}
            type="button"
            className="btn btn-secondary"
            onClick={() => setShowActivateModal(false)}
          >
            {t("Cancel")}
          </button>
          <button
            id={`InactiveControlModalActivateConfirm_${row.batchControlId}`}
            type="button"
            className="btn btn-danger m-2"
            onClick={handleActivate}
          >
            {t("Active")}
          </button>
        </BootstrapModal.Footer>
      </BootstrapModal>
    </>
  );
}

export default InactiveControlsRow;
